<template>
  <router-link
    v-slot="{ href, isActive, isExactActive, navigate }"
    v-bind="$attrs"
    class="flex transition-colors duration-100 ease-out border-b border-gray-300 menu-item last:border-0"
    :class="{
      'text-gray-700': !disabled,
      'text-gray-400 pointer-events-none': disabled,
      'is-disabled': disabled,
    }"
  >
    <a
      class="flex items-center justify-between flex-1 h-16 pl-3"
      :class="{ 'is-active': isActive || isExactActive }"
      :href="href"
      @click="navigate"
      @mouseenter="isMouseOver = true"
      @mouseleave="isMouseOver = false"
    >
      <div class="flex items-center">
        <slot
          name="icon"
          :is-active="isActive"
          :is-exact-active="isExactActive"
          :is-mouse-over="isMouseOver"
        >
          <mia-streamline-icon
            :src="icon"
            class="w-6 h-6 transition-colors duration-100 ease-out fill-current icon"
            :class="{
              'text-gray-500': !disabled,
              'text-gray-300': disabled
            }"
          />
        </slot>

        <span class="ml-3">
          <slot />
        </span>
      </div>

      <span
        v-if="!isBooked"
        class="block px-1 py-1"
      >
        <mia-streamline-icon
          src="shipment-download"
          class="w-6 h-6 text-indigo-600 fill-current"
        />
      </span>
      <span
        v-else-if="isCompleted"
        class="block p-2 bg-green-500 rounded-full shadow-lg"
      >
        <mia-streamline-icon
          src="check-circle"
          class="w-4 h-4 text-white fill-current"
        />
      </span>
      <vue-radial-progress-bar
        v-else-if="!withoutProgress"
        :completed-steps="completedSteps"
        :diameter="48"
        :stroke-width="3"
        :total-steps="100"
        inner-stroke-color="transparent"
        start-color="#48bb78"
        stop-color="#48bb78"
        :class="{ 'opacity-50': disabled }"
      >
        <span
          class="text-xs text-gray-700"
        >
          {{ progress }}<span style="font-size: 8px;">%</span>
        </span>
      </vue-radial-progress-bar>
    </a>
  </router-link>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
  name: 'MiaCarEditMenuItem',

  components: {
    'vue-radial-progress-bar': RadialProgressBar
  },

  props: {
    icon: {
      type: String,
      default: ''
    },

    progress: {
      type: Number,
      default: 0
    },

    withoutProgress: {
      type: Boolean,
      default: false
    },

    isBooked: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isMouseOver: false
    }
  },

  computed: {
    isCompleted() {
      return this.progress === 100
    },

    completedSteps() {
      const steps = parseInt(this.progress.toFixed(), 10)

      return steps === 0 ? 5 : steps
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-item:not(.is-disabled) {
  &:hover,
  &.is-active {
    @apply text-orange-mia;

    .icon {
      @apply text-gray-800;
    }
  }
}
</style>
